import { RouteConfig } from 'vue-router';
import PublicRoutes from '@/router/PublicRoutes';
import AdminRoutes from '@/router/AdminRoutes';

const routes: RouteConfig[] = [...PublicRoutes, ...AdminRoutes];

export default routes;
